import React, {useEffect, useState} from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import {ELEMENT_PICKER_TYPES} from "../util/Constants";


function ElementPicker(props) {
    const [elRefs, setElRefs] = useState([]);
    const arrLength = props.allElements.length;
    useEffect(() => {
        // add or remove refs
        setElRefs(elRefs => (
            Array(arrLength).fill().map((_, i) => elRefs[i] || React.createRef())
        ));
    }, [arrLength]);

    useEffect(() => {
        centerActiveElements();
    }, [props.defaultPicked]);

    const centerActiveElements = () => {
        elRefs.forEach(ref=>{
            if (ref.current?.className.includes("active")) {
                ref.current?.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "center"
                });
            }
        })
    }

    const handleSelect = (index, selectedValue) => {
        setActiveStyle(index);
        if (props.typeOfPicker === ELEMENT_PICKER_TYPES.HOUR_PICKER) {
            props.handlePickedHour(selectedValue);
        }else if (props.typeOfPicker === ELEMENT_PICKER_TYPES.NUMBER_OF_PEOPLE_PICKER) {
            props.handleGuestNumberChange(selectedValue);
        }
    };

    const setActiveStyle = (id) => {
        elRefs.forEach(ref=>{
            ref.current.className="element";
        })
        if (elRefs[id]!=null) {
            elRefs[id].current.className="element active";
        }
    };

    return (
        <section className={props.extraClassName? "all-elements-list" + " " + props.extraClassName : "all-elements-list"}>
            <div className="row title">
                <p>{props.title}</p>
            </div>
            <ScrollContainer className="scroll-container">
                <ul className="element-picker">
                    {props.allElements.map((selectedValue, index) => (
                        <li
                            ref={elRefs[index]}
                            className={props.defaultPicked === selectedValue ? "element active": "element"}
                            key={index}
                            onClick={(e) => handleSelect(index, selectedValue)}
                            data-qa={props.dataQAIdentifier}
                            data-qa-value={selectedValue}
                        >
                            <a>{selectedValue}</a>
                        </li>
                    ))}
                </ul>
            </ScrollContainer>
        </section>
    );

}



export default ElementPicker;
